import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/GROUPS';
export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(`${domain}/FETCH_ALL`, institutionId => ({institutionId}));

export const {
    action: create,
    success: createSuccess,
    failed: createFailed,
} = createAction(`${domain}/CREATE`, (institutionId, title) => ({institutionId, title}));

export const {
    action: star,
    success: starSuccess,
    failed: starFailed,
} = createAction(
    `${domain}/STAR`,
    groupId => ({groupId}),
    groupId => ({groupId}),
    groupId => ({groupId}),
);

export const {
    action: unStar,
    success: unStarSuccess,
    failed: unStarFailed,
} = createAction(
    `${domain}/UNSTAR`,
    groupId => ({groupId}),
    groupId => ({groupId}),
    groupId => ({groupId}),
);
